export default "__VITE_ASSET__CLgaZS1M__"